// import 'highcharts/modules/no-data-to-display';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Fragment, useEffect, useState } from 'react';

export const NormalBookingGraph = ({ data }: any) => {
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    if (!Array.isArray(data?.items)) return;

    const months = data?.items.map((item: any) => item.Name ?? 'N/A');
    const onlineData = data?.items.map((item: any) => item.OnlineValue ?? 0);
    const offlineData = data?.items.map((item: any) => item.OfflineValue ?? 0);
    // const onlineRevenue = data?.items.map((item: any) => item.OnlineTotal ?? 0);
    // const offlineRevenue = data?.items.map(
    //   (item: any) => item.OfflineTotal ?? 0,
    // );

    const colors = ['#35B1E8', '#FFA51F'];

    setChartOptions({
      chart: {
        type: 'column',
      },
      title: {
        text: 'Normal Booking (Online vs Offline)',
        style: {
          fontSize: '14px',
        },
      },
      xAxis: {
        categories: months,
        crosshair: true,
        title: {
          text: 'Months',
          style: {
            fontSize: '11px',
          },
        },
        labels: {
          style: {
            fontSize: '11px',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Total Bookings',
        },
      },
      tooltip: {
        shared: true,
        useHTML: true,
        formatter: function (this: any) {
          const index = this.points?.[0]?.point.index ?? 0;

          return `
            <b>${months[index]}</b><br/>
            <span style="color:${colors[0]}">●</span> Online Booking: <b>${onlineData[index]}</b><br/>
            <span style="color:${colors[1]}">●</span> Offline Booking: <b>${offlineData[index]}</b><br/>
          `;
        },
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'Online Booking',
          data: onlineData,
          color: colors[0],
        },
        {
          name: 'Offline Booking',
          data: offlineData,
          color: colors[1],
        },
      ],
      // lang: {
      //   noData: 'No data found',
      // },
      // noData: {
      //   style: {
      //     fontWeight: 'bold',
      //     fontSize: '14px',
      //     color: '#666',
      //   },
      // },
    });
  }, [data]);

  return (
    <Fragment>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </Fragment>
  );
};
